<title mat-dialog-title>MOU Conditions</title>
<mat-dialog-content>
  <p>You need to accept the terms and conditions to continue with your registration</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="danger" (click)="close()">understood</button>
</mat-dialog-actions>
